import React from 'react';
import BusinessCard from './components/BusinessCard';
import './App.css';

function App() {
  return (
    <div className="App">
      <BusinessCard />
    </div>
  );
}

export default App;
